import { memo } from 'react';
import RoleButton from './RoleButton';
import { Modal } from '@ds';
import { useHeaderStore } from 'src/stores/HeaderStore';
import styles from './RoleButton.module.scss';
import { useGetUser } from 'src/shared/queries/useGetUser';
import { USER_TYPES } from 'src/utils/constants/common';

const beneficiarySubText = 'View immigration information for myself';
const hrProfileSubText = 'View the immigration information for the cases I manage';

enum UserRoles {
  Beneficiary = 'beneficiary',
  HR = 'hr',
}

const RolesSelector = () => {
  const { isSwitchRolesModalOpen, closeSwitchRolesModal } = useHeaderStore();
  const { data: user } = useGetUser();
  const isManagerFNDualRole = user ? (user.linkedUsers?.length > 0 && user.linkedUsers.some((linkedUser: { userType: string }) => linkedUser.userType === USER_TYPES.manager)) : false;
  const hrProfileMainText =  isManagerFNDualRole ? 'Manager Profile' : 'HR (Corporate) Profile';

  const onRoleSelect = async (role: UserRoles) => {
    if (role === UserRoles.Beneficiary) {
      closeSwitchRolesModal();
    }

    if (role === UserRoles.HR) {
      window.open(window.FN_CONFIG.HR_UI_URL, '_self');
    }
  };

  return (
    <Modal
      title="MY ROLES"
      visible={isSwitchRolesModalOpen}
      onModalClosed={closeSwitchRolesModal}
      className={styles['roles-selector-modal']}
    >
      <div onClick={() => onRoleSelect(UserRoles.Beneficiary)}>
        <RoleButton isCurrent={true} mainText={'Beneficiary Profile'} subText={beneficiarySubText} />
      </div>
      <div onClick={() => onRoleSelect(UserRoles.HR)}>
        <RoleButton isCurrent={false} mainText={hrProfileMainText} subText={hrProfileSubText} />
      </div>
    </Modal>
  );
};

export default memo(RolesSelector);
